import React from "react";

export function createGlobalState<T = never>(defaultValue: T) {
  const Context = React.createContext({ v: defaultValue, s: (_x: T) => {} });

  function Provider(props: { children: React.ReactElement<any> }) {
    const [v, s] = React.useState(defaultValue);
    return React.createElement(
      Context.Provider,
      { value: { v, s } },
      props.children,
    );
  }

  function useGlobalState(): T {
    const x = React.useContext(Context);
    return x.v;
  }

  function useGlobalEffect(fn: () => T, watches: unknown[] = []) {
    const x = React.useContext(Context);
    React.useEffect(() => x.s(fn()), watches);
  }

  return {
    Provider,
    useGlobalState,
    useGlobalEffect,
  };
}
